import type {CSS} from '@pinecast/styles';
import styled from '@pinecast/styles';
import * as React from 'react';

export type CalloutType = 'info' | 'negative' | 'positive' | 'promotion';

const Callout_ = styled(
  'div',
  (
    {$hasAction, $type}: {$hasAction: boolean; $type: CalloutType},
    designColors,
  ) => ({
    alignItems: 'center',
    backgroundColor:
      $type === 'info'
        ? designColors.badgeBlueBackground
        : $type === 'negative'
          ? designColors.badgeRedBackground
          : $type === 'positive'
            ? designColors.badgeGreenBackground
            : designColors.promotionBackground,
    borderRadius: '6px',
    borderColor: 'currentColor',
    // $type === 'info'
    //   ? designColors.borderBlueNormal
    //   : $type === 'negative'
    //   ? designColors.borderRedAccent
    //   : designColors.borderGreenNormal,
    borderWidth: 1,
    borderStyle: 'solid',
    boxShadow: '0 1px 0 rgba(0, 0, 0, 0.15)',
    color:
      $type === 'info'
        ? designColors.badgeBlueText
        : $type === 'negative'
          ? designColors.badgeRedText
          : $type === 'positive'
            ? designColors.badgeGreenText
            : designColors.promotionText,
    display: 'flex',
    fontWeight: 500,
    justifyContent: $hasAction ? 'space-between' : undefined,
    marginBottom: 12,
    padding: 12,
    ':not(:empty) > .ActionWrapper > .Link': {
      color: 'inherit',
    },
  }),
  {className: 'Callout'},
);

const ActionWrap = styled(
  'div',
  {marginRight: 12},
  {className: 'ActionWrapper'},
);

const Callout = ({
  action,
  children,
  style,
  type,
}: {
  action?: React.ReactNode;
  children: React.ReactNode;
  style?: CSS;
  type: CalloutType;
}) => (
  <Callout_
    $hasAction={action != null}
    $type={type}
    style={style}
    role={type !== 'info' ? 'alert' : undefined}
  >
    {action ? (
      <>
        <ActionWrap>{children}</ActionWrap>
        {action}
      </>
    ) : (
      <div className="ActionWrapper">{children}</div>
    )}
  </Callout_>
);

export default Callout;
